import React from "react";
import { TableCell, TableRow, IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  findCust,
  findFundAbbById,
  findStrategy,
  formatValueDecimal,
} from "../../component/Methods";
import {
  buildParentDisplay,
  formatDate,
  formatSigned,
} from "./boxedPositionsUtils";
import { cellSx, expandCellSx } from "./boxedPositionsTableStyles";

const BoxedPositionGroupRows = ({
  row,
  theme,
  isOpen,
  onToggle,
  funds,
  strategies,
  custodians,
}) => {
  const lots = Array.isArray(row.lots) ? row.lots : [];
  const hasData = lots.length > 0;
  const parent = buildParentDisplay(row, strategies, custodians, funds);

  return (
    <>
      <TableRow
        sx={{
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        }}
      >
        <TableCell sx={expandCellSx(theme)}>
          {hasData && (
            <IconButton
              size="small"
              onClick={() => onToggle(row.id)}
              sx={{
                color: theme.palette.text.secondary,
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell sx={cellSx(theme)}>{parent.dateLabel}</TableCell>
        <TableCell sx={cellSx(theme)}>{parent.positionType}</TableCell>
        <TableCell
          sx={{
            ...cellSx(theme),
            fontWeight: 600,
            color: theme.palette.primary.main,
          }}
        >
          {parent.tickerLabel}
        </TableCell>
        <TableCell sx={cellSx(theme)}>{parent.fundLabel}</TableCell>
        <TableCell sx={cellSx(theme)}>{parent.strategyLabel}</TableCell>
        <TableCell sx={cellSx(theme)}>{parent.custodianLabel}</TableCell>
        <TableCell align="right" sx={cellSx(theme, { numeric: true })}>
          {formatSigned(parent.shares)}
        </TableCell>
        <TableCell align="right" sx={cellSx(theme, { numeric: true })}>
          {formatSigned(parent.cost)}
        </TableCell>
        <TableCell align="right" sx={cellSx(theme, { numeric: true })}>
          {parent.price == null
            ? "-"
            : formatSigned(parent.price, formatValueDecimal)}
        </TableCell>
      </TableRow>

      {hasData &&
        isOpen &&
        lots.map((lot, lotIndex) => {
          const shareCount = Number(lot?.shareCount) || 0;
          const cost = Number(lot?.cost) || 0;

          return (
            <TableRow
              key={`${row.id}-lot-${lot.lotId || lotIndex}`}
              sx={{
                backgroundColor: theme.palette.grey[50],
                "&:hover": {
                  backgroundColor: theme.palette.grey[100],
                },
              }}
            >
              <TableCell sx={expandCellSx(theme)} />
              <TableCell sx={cellSx(theme, { muted: true })}>
                {formatDate(lot?.date)}
              </TableCell>
              <TableCell sx={cellSx(theme, { muted: true })}>
                {lot?.position === 0 ? "Long" : "Short"}
              </TableCell>
              <TableCell sx={cellSx(theme, { muted: true })}>
                {lot?.ticker?.symbol
                  ? String(lot.ticker.symbol).toUpperCase()
                  : parent.tickerLabel}
              </TableCell>
              <TableCell sx={cellSx(theme, { muted: true })}>
                {lot?.fund
                  ? findFundAbbById(lot.fund, funds) || "-"
                  : parent.fundLabel}
              </TableCell>
              <TableCell sx={cellSx(theme, { muted: true })}>
                {findStrategy(lot?.strategy, strategies) || "-"}
              </TableCell>
              <TableCell sx={cellSx(theme, { muted: true })}>
                {findCust(lot?.account?.custodian, custodians) || "-"}
              </TableCell>
              <TableCell
                align="right"
                sx={cellSx(theme, { muted: true, numeric: true })}
              >
                {formatSigned(shareCount)}
              </TableCell>
              <TableCell
                align="right"
                sx={cellSx(theme, { muted: true, numeric: true })}
              >
                {formatSigned(cost)}
              </TableCell>
              <TableCell
                align="right"
                sx={cellSx(theme, { muted: true, numeric: true })}
              >
                {formatSigned(lot?.sharePrice, formatValueDecimal)}
              </TableCell>
            </TableRow>
          );
        })}
    </>
  );
};

export default BoxedPositionGroupRows;
